import RecentTrucks from './RecentTrucks';
export default RecentTrucks;
